import { motion } from "framer-motion";
import type { AllaahName } from "@/data/duas";

interface NameCardProps {
  name: AllaahName;
  index: number;
}

export const NameCard = ({ name, index }: NameCardProps) => {
  return (
    <motion.div
      className="border-l-2 border-gold/30 pl-6 py-2 space-y-3"
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: index * 0.1 }}
    >
      <div className="flex items-baseline gap-4 flex-wrap">
        <p className="font-arabic text-3xl text-ink">
          {name.arabic}
        </p>
        <p className="font-display text-lg text-espresso">
          {name.transliteration}
        </p>
      </div>
      <p className="text-sm italic text-muted-foreground">
        {name.meaning}
      </p>
      <p className="text-foreground/80 leading-relaxed">
        {name.reflection}
      </p>
    </motion.div>
  );
};
